<template>
  <div class="preventiva-os_erp ml-4 mr-4" >
      <b-form>          
          <b-row>
              <b-col>
                  <b-form-group label="Carro:" label-for="preventiva-historico">
                      <b-form-input id="preventiva-historico" type="text"
                        v-model="carro" required                        
                        placeholder="Informe o prefixo do veículo.." />
                  </b-form-group>
              </b-col>

            <b-col >                                    
                <br>
                <b-button  variant="success" :disabled="carregando" @click="carregando = true, loadPreventivasHistorico() " >
                    <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                </b-button >                     
            </b-col>

          </b-row>

          <b-row>

          </b-row>
    </b-form>
                             <!--sticky-header trava o cabeçalho da tabela -->    
    <b-table  small hover striped sticky-header="530px" :items="preventivashistoricos" :fields="fields">                            
        
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'PreventivaHistorico',

    data: function() {  
       
        return {
            mode: 'save',
            carregando: false,
            preventivashistorico: {},
            preventivashistoricos: [],            
            fields: [                
                { key: 'dt_emissao', label: 'Data emissão', sortable: true, formatter: (value, key, preventivashistoricos) => {
                    return moment(preventivashistoricos.dt_emissao).format('DD/MM/YYYY').replace('Invalid date','-');} },                
                { key: 'carro', label: 'Carro', sortable: true },                                                           
                { key: 'os_erp', label: 'Nro O.S', sortable: true },                              
                { key: 'id_servico', label: 'Codigo', sortable: true },
                { key: 'servico', label: 'Serviço', sortable: true },
                { key: 'dt_inicio_servico', label: 'Inicio serviço', sortable: true, formatter: (value, key, preventivashistoricos) => {
                    return moment(preventivashistoricos.dt_inicio_servico).format('DD/MM/YYYY HH:MM').replace('Invalid date','-');} },                
                { key: 'dt_fim_servico', label: 'Fim serviço', sortable: true, formatter: (value, key, preventivashistoricos) => {                    
                    return moment(preventivashistoricos.dt_fim_servico).format('DD/MM/YYYY HH:MM').replace('Invalid date','-');} },                                          
                //{ key: 'duracao', label: 'Duração', sortable: true, formatter: (value, key, preventivashistoricos) => {                    
                //    return moment(preventivashistoricos.dt_fim_servico).format('DDD/MM/YYYY HH:MM').replace('Invalid date','-');} },  
                { key: 'km_executado', label: 'KM executado', sortable: true },
                { key: 'km_programado', label: 'KM programado', sortable: true },
                { key: 'km_atual', label: 'Atual', sortable: true },                
                { key: 'km_restante', label: 'Restante', sortable: true },                
                { key: 'executante', label: 'Executante', sortable: true },
                { key: 'programa', label: 'Fechado Via', sortable: true }                 
            ],
        }        
    },  
    
    methods: {
        loadPreventivasHistorico() {                        
            const url = `${baseApiUrl}/preventiva/historico/${this.carro}`                               
            axios.get(url).then(res => {                                
                this.carregando = false;
                this.preventivashistoricos = res.data                
            })            
        },



        
    },
    mounted() {
        this.loadPreventivasHistorico()
    }
}
</script>

<style>

</style>
